export const SET_BATCHES = 'SET_BATCHES';
export const FETCH_BATCHES_FAILED = 'FETCH_BATCHES_FAILED';
export const FETCH_BATCHES_START = 'FETCH_ORDERS_START';
export const INITIALIZE_BATCH = 'INITIALIZE_BATCH'

export const SAVE_BATCH_SUCCESS = 'SAVE_BATCH_SUCCESS';
export const SUBMIT_BATCH_SUCCESS = 'SUBMIT_BATCH_SUCCESS';

export const AUTH_BATCH_SUCCESS = 'AUTH_BATCH_SUCCESS';
export const AUTH_BATCH_FAILED = 'AUTH_BATCH_FAILED';
export const AUTH_BATCH_START = 'AUTH_BATCH_START';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH'; 
